<script>
export default {
    name: 'Formatter',

    methods: {
        phoneFormatter(value) {
            let phone = ''
            const separator = ' '
            const cleanString = this.numericString(value)
            phone = cleanString.slice(0, 2)
            if (cleanString.length > 2) {
                phone += separator + cleanString.slice(2, 4)
            }
            if (cleanString.length > 4) {
                phone += separator + cleanString.slice(4, 6)
            }
            if (cleanString.length > 6) {
                phone += separator + cleanString.slice(6, 8)
            }
            if (cleanString.length > 8) {
                phone += separator + cleanString.slice(8, 10)
            }
            return phone
        },

        ibanFormatter(value) {
            let iban = ''
            const separator = ' '
            const cleanString = this.alphaNumericString(value)
            iban = cleanString.slice(0, 4)
            if (cleanString.length > 4) {
                iban += separator + cleanString.slice(4, 8)
            }
            if (cleanString.length > 8) {
                iban += separator + cleanString.slice(8, 12)
            }
            if (cleanString.length > 12) {
                iban += separator + cleanString.slice(12, 16)
            }
            if (cleanString.length > 16) {
                iban += separator + cleanString.slice(16, 20)
            }
            if (cleanString.length > 20) {
                iban += separator + cleanString.slice(20, 24)
            }
            if (cleanString.length > 24) {
                iban += separator + cleanString.slice(24, 27)
            }
            return iban
        },

        dateFormatter(value) {
            let formattedDate = ''
            const separator = '/'
            const cleanString = this.numericString(value)
            formattedDate = cleanString.slice(0, 2)
            if (cleanString.length > 2) {
                formattedDate += separator + cleanString.slice(2, 4)
            }
            if (cleanString.length > 4) {
                formattedDate += separator + cleanString.slice(4, 8)
            }
            return formattedDate
        },

        sirenFormatter(value) {
            let formattedSiren = ''
            const separator = ' '
            const cleanString = this.numericString(value)
            formattedSiren = cleanString.slice(0, 3)
            if (cleanString.length > 3) {
                formattedSiren += separator + cleanString.slice(3, 6)
            }
            if (cleanString.length > 6) {
                formattedSiren += separator + cleanString.slice(6, 9)
            }
            if (cleanString.length > 9) {
                formattedSiren += separator + cleanString.slice(9, 14)
            }
            return formattedSiren
        },

        accountFormatter(value) {
            let formattedAccount = ''
            const cleanString = this.numericString(value)
            formattedAccount = cleanString.slice(0, 6)
            return formattedAccount
        },

        numericString(string) {
            let cleanString = ''
            if (string !== null) {
                for (let i = 0; i < string.length; i++) {
                    const char = string.charAt(i)
                    if (char >= '0' && char <= '9') {
                        cleanString += char
                    }
                }
            }
            return cleanString
        },

        alphaNumericString(string) {
            let cleanString = ''
            if (string !== null) {
                for (let i = 0; i < string.length; i++) {
                    const char = string.charAt(i)
                    if (char >= '0' && char <= '9') {
                        cleanString += char
                    } else if (char.match(/[a-z]/i)) {
                        cleanString += char
                    }
                }
            }
            return cleanString
        },

        decimalString(string) {
            let cleanString = ''
            if (string !== null) {
                for (let i = 0; i < string.length; i++) {
                    const char = string.charAt(i)
                    if (char >= '0' && char <= '9') {
                        cleanString += char
                    } else if (char === ',' || char === '.') {
                        cleanString += '.'
                    }
                }
            }
            return cleanString
        },

        twoDigitsFormatter(value) {
            let formattedNumber = ''
            const separator = ' '
            const cleanString = this.numericString(value)
            formattedNumber = cleanString.slice(0, 2)
            if (cleanString.length > 2) {
                formattedNumber += `.${cleanString.slice(2, 4)}`
            }
            if (cleanString.length > 4) {
                formattedNumber += separator + cleanString.slice(4, 6)
            }
            return formattedNumber
        },
    },
}
</script>
